import { useState, useMemo, useRef, useEffect, useCallback } from 'react'
import { FormInstance } from 'antd/lib/form'
import { debounce } from 'lodash'
import {
  ReportFieldConfigVO,
  POST_CALCULATE_RELATE_FIELD_VALUES,
} from '@/api/reportApi'

interface UseRelateFieldCalcOptions {
  reportFieldConfigList: ReportFieldConfigVO[]
  platform_form: FormInstance
  /** 当前项目编码，goodsdetail 从 itemsList[0]?.code 获取 */
  projectCode: string | undefined
  /** 计算完成并 setFieldsValue 之后的回调，用于触发页面缓存等副作用 */
  onAfterCalc?: () => void
}

/**
 * 关联字段计算逻辑 —— 共享 hook
 * 根据 reportFieldConfigList 构建关联映射，在源字段 blur 时调用接口计算目标字段值。
 */
export const useRelateFieldCalc = ({
  reportFieldConfigList,
  platform_form,
  projectCode,
  onAfterCalc,
}: UseRelateFieldCalcOptions) => {
  const [relateFieldCalcLoading, setRelateFieldCalcLoading] = useState(false)

  // 从 reportFieldConfigList 中构建映射关系：relateFieldKey → 目标字段配置列表
  const relateFieldMap = useMemo(() => {
    const map = new Map<string, ReportFieldConfigVO[]>()
    reportFieldConfigList?.forEach((cfg) => {
      if (cfg.hasRelateField === 1 && cfg.relateFieldKey) {
        const arr = map.get(cfg.relateFieldKey) || []
        arr.push(cfg)
        map.set(cfg.relateFieldKey, arr)
      }
    })
    return map
  }, [reportFieldConfigList])

  // 需要监听 blur 的 GoodsSubmissionInfo 字段 Key 集合
  const relateFieldKeySet = useMemo(() => {
    return new Set(relateFieldMap.keys())
  }, [relateFieldMap])

  // 用 ref 保持最新上下文，避免防抖函数闭包捕获旧值
  const relateFieldCtxRef = useRef({
    relateFieldMap,
    projectCode,
    platform_form,
    setRelateFieldCalcLoading,
  })
  useEffect(() => {
    relateFieldCtxRef.current = {
      relateFieldMap,
      projectCode,
      platform_form,
      setRelateFieldCalcLoading,
    }
  }, [relateFieldMap, projectCode, platform_form])

  // onAfterCalc 回调用独立 ref，每次渲染更新，避免加入 useEffect 依赖
  const onAfterCalcRef = useRef(onAfterCalc)
  onAfterCalcRef.current = onAfterCalc

  // 防抖计算函数
  const debouncedRelateFieldCalc = useMemo(
    () =>
      debounce(async (fieldKey: string, value: any) => {
        const {
          relateFieldMap,
          projectCode,
          platform_form,
          setRelateFieldCalcLoading,
        } = relateFieldCtxRef.current
        const targetFields = relateFieldMap.get(fieldKey)
        if (!targetFields?.length) return

        // 空值时清空对应目标字段
        if (value === undefined || value === null || value === '') {
          const clearValues: Record<string, any> = {}
          targetFields.forEach((cfg) => {
            clearValues[`reportField_${cfg.fieldKey}`] = undefined
          })
          platform_form.setFieldsValue(clearValues)
          onAfterCalcRef.current?.()
          return
        }

        setRelateFieldCalcLoading(true)
        try {
          const res = await POST_CALCULATE_RELATE_FIELD_VALUES({
            platformCode: projectCode!,
            relateFieldKey: fieldKey,
            relateFieldValue: String(value),
          })
          const list = (res as any)?.data?.data || (res as any)?.data || []
          if (Array.isArray(list)) {
            const fillValues: Record<string, any> = {}
            list.forEach((item: any) => {
              if (item.fieldKey) {
                fillValues[`reportField_${item.fieldKey}`] =
                  item.calculatedValue
              }
            })
            platform_form.setFieldsValue(fillValues)
            onAfterCalcRef.current?.()
          }
        } catch (error) {
          console.error('关联字段计算失败:', error)
        } finally {
          setRelateFieldCalcLoading(false)
        }
      }, 500),
    [],
  )

  // blur 回调，传给 GoodsSubmissionInfo
  const handleRelateFieldBlur = useCallback(
    (fieldKey: string, value: any) => {
      debouncedRelateFieldCalc(fieldKey, value)
    },
    [debouncedRelateFieldCalc],
  )

  return {
    relateFieldKeySet,
    handleRelateFieldBlur,
    relateFieldCalcLoading,
  }
}
import { useState, useMemo, useRef, useEffect, useCallback } from 'react'
import { FormInstance } from 'antd/lib/form'
import { debounce } from 'lodash'
import {
  ReportFieldConfigVO,
  POST_CALCULATE_RELATE_FIELD_VALUES,
} from '@/api/reportApi'

interface UseRelateFieldCalcOptions {
  reportFieldConfigList: ReportFieldConfigVO[]
  platform_form: FormInstance
  /** 当前项目编码，goodsdetail 从 itemsList[0]?.code 获取 */
  projectCode: string | undefined
  /** 计算完成并 setFieldsValue 之后的回调，用于触发页面缓存等副作用 */
  onAfterCalc?: () => void
}

/**
 * 关联字段计算逻辑 —— 共享 hook
 * 根据 reportFieldConfigList 构建关联映射，在源字段 blur 时调用接口计算目标字段值。
 */
export const useRelateFieldCalc = ({
  reportFieldConfigList,
  platform_form,
  projectCode,
  onAfterCalc,
}: UseRelateFieldCalcOptions) => {
  const [relateFieldCalcLoading, setRelateFieldCalcLoading] = useState(false)

  // 从 reportFieldConfigList 中构建映射关系：relateFieldKey → 目标字段配置列表
  const relateFieldMap = useMemo(() => {
    const map = new Map<string, ReportFieldConfigVO[]>()
    reportFieldConfigList?.forEach((cfg) => {
      if (cfg.hasRelateField === 1 && cfg.relateFieldKey) {
        const arr = map.get(cfg.relateFieldKey) || []
        arr.push(cfg)
        map.set(cfg.relateFieldKey, arr)
      }
    })
    return map
  }, [reportFieldConfigList])

  // 需要监听 blur 的 GoodsSubmissionInfo 字段 Key 集合
  const relateFieldKeySet = useMemo(() => {
    return new Set(relateFieldMap.keys())
  }, [relateFieldMap])

  // 用 ref 保持最新上下文，避免防抖函数闭包捕获旧值
  const relateFieldCtxRef = useRef({
    relateFieldMap,
    projectCode,
    platform_form,
    setRelateFieldCalcLoading,
  })
  useEffect(() => {
    relateFieldCtxRef.current = {
      relateFieldMap,
      projectCode,
      platform_form,
      setRelateFieldCalcLoading,
    }
  }, [relateFieldMap, projectCode, platform_form])

  // onAfterCalc 回调用独立 ref，每次渲染更新，避免加入 useEffect 依赖
  const onAfterCalcRef = useRef(onAfterCalc)
  onAfterCalcRef.current = onAfterCalc

  // 防抖计算函数
  const debouncedRelateFieldCalc = useMemo(
    () =>
      debounce(async (fieldKey: string, value: any) => {
        const {
          relateFieldMap,
          projectCode,
          platform_form,
          setRelateFieldCalcLoading,
        } = relateFieldCtxRef.current
        const targetFields = relateFieldMap.get(fieldKey)
        if (!targetFields?.length) return

        // 空值时清空对应目标字段
        if (value === undefined || value === null || value === '') {
          const clearValues: Record<string, any> = {}
          targetFields.forEach((cfg) => {
            clearValues[`reportField_${cfg.fieldKey}`] = undefined
          })
          platform_form.setFieldsValue(clearValues)
          onAfterCalcRef.current?.()
          return
        }

        setRelateFieldCalcLoading(true)
        try {
          const res = await POST_CALCULATE_RELATE_FIELD_VALUES({
            platformCode: projectCode!,
            relateFieldKey: fieldKey,
            relateFieldValue: String(value),
          })
          const list = (res as any)?.data?.data || (res as any)?.data || []
          if (Array.isArray(list)) {
            const fillValues: Record<string, any> = {}
            list.forEach((item: any) => {
              if (item.fieldKey) {
                fillValues[`reportField_${item.fieldKey}`] =
                  item.calculatedValue
              }
            })
            platform_form.setFieldsValue(fillValues)
            onAfterCalcRef.current?.()
          }
        } catch (error) {
          console.error('关联字段计算失败:', error)
        } finally {
          setRelateFieldCalcLoading(false)
        }
      }, 500),
    [],
  )

  // blur 回调，传给 GoodsSubmissionInfo
  const handleRelateFieldBlur = useCallback(
    (fieldKey: string, value: any) => {
      debouncedRelateFieldCalc(fieldKey, value)
    },
    [debouncedRelateFieldCalc],
  )

  return {
    relateFieldKeySet,
    handleRelateFieldBlur,
    relateFieldCalcLoading,
  }
}
